import { useMemo, useState } from "react";
import { UserPlus, Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useProfiles } from "@/lib/profiles";
import { ProfileDialog } from "@/components/ProfileDialog";
import { cn } from "@/lib/utils";
import { t } from "@/i18n";

export const PersonInput = ({ value, onChange, kind = "artist", placeholder = "Nombre", testId, className = "" }) => {
  const { profiles } = useProfiles();
  const [focus, setFocus] = useState(false);
  const [dialog, setDialog] = useState(false);
  const q = (value || "").trim().toLowerCase();
  const matches = useMemo(() => profiles.filter((p) => (p.kind === kind || p.kind === "both") && (!q || p.name.toLowerCase().includes(q))).slice(0, 6), [profiles, kind, q]);
  const exact = profiles.find((p) => p.name.toLowerCase() === q);
  const showList = focus && matches.length > 0 && !(matches.length === 1 && exact);

  return (
    <div className={cn("relative", className)}>
      <div className="flex gap-1">
        <Input value={value} onChange={(e) => onChange(e.target.value)} onFocus={() => setFocus(true)} onBlur={() => setTimeout(() => setFocus(false), 150)}
          placeholder={placeholder} data-testid={`${testId}`} className={cn("h-9", exact && "pr-7")} autoComplete="off" />
        {exact && <Check className="h-3.5 w-3.5 text-emerald-400 absolute right-10 top-1/2 -translate-y-1/2 pointer-events-none" title={t("Perfil existente")} />}
        <button type="button" onClick={() => setDialog(true)} title={t(exact ? "Perfil ya registrado" : "Crear perfil con los datos que pide Downtown")} disabled={!!exact}
          className={cn("h-9 w-9 shrink-0 grid place-items-center rounded-md border border-border text-muted-foreground transition-colors", exact ? "opacity-40" : "hover:text-primary hover:border-primary/50")}
          data-testid={`${testId}-create-profile`}>
          <UserPlus className="h-4 w-4" />
        </button>
      </div>
      {showList && (
        <ul className="absolute z-30 mt-1 w-full rounded-md border border-border bg-popover shadow-xl overflow-hidden" data-testid={`${testId}-suggestions`}>
          {matches.map((p) => (
            <li key={p.id}>
              <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { onChange(p.name); setFocus(false); }}
                className="w-full text-left px-3 py-1.5 text-sm hover:bg-muted flex items-center justify-between" data-testid={`${testId}-suggestion-${p.id}`}>
                <span>{p.name}</span>
                {p.downtown_status === "created" || p.downtown_status === "exists" ? <span className="text-[10px] text-emerald-400">{t("en Downtown")}</span> : null}
              </button>
            </li>
          ))}
        </ul>
      )}
      {dialog && <ProfileDialog open onClose={() => setDialog(false)} initial={{ name: value, kind }} onSaved={(p) => onChange(p.name)} />}
    </div>
  );
};
